import { GuessAreaResponse } from '../../guess-area';

export const mockGuessAreaResponse: GuessAreaResponse = {
  areaNames: ['シー', 'メディテレーニアンハーバー', 'ポルトパラディーゾ'],
};
